import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'loyaltic-click-to-play',
  templateUrl: './click-to-play.component.html',
  styleUrls: ['./click-to-play.component.scss']
})
export class ClickToPlayComponent implements OnInit {

  constructor( private router: Router,
    public translate: TranslateService) {
  }

  ngOnInit() {
  }

  onPlayClick() {
    this.router.navigate(['play'])
  }

}
